import Icon from '../components/Icon.vue'

Icon.register({
  mountain: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M634.9 462.7c2.8 4.4 5.1 12.1 5.1 17.3 0 4.5-1.8 11.4-3.9 15.3-5.6 10.3-16.4 16.7-28.1 16.7h-576 0c-10.5 0-23.1-7.5-28.1-16.7-2.2-4-3.9-10.8-3.9-15.3 0-5.2 2.3-12.9 5.1-17.3l288-448c5.9-9.2 16-14.7 26.9-14.7s21 5.5 26.9 14.7zM320 91.2l-102.1 158.8 38.1 38.1 64-64h85.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/mountain.js
// module id = 1588
// module chunks = 0